import { render, staticRenderFns } from "./NotificaMe.vue?vue&type=template&id=29d9a96d&"
import script from "./NotificaMe.vue?vue&type=script&lang=js&"
export * from "./NotificaMe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports